import { render, staticRenderFns } from "./no_pay_popup.vue?vue&type=template&id=4f70debf&scoped=true"
import script from "./no_pay_popup.vue?vue&type=script&lang=js"
export * from "./no_pay_popup.vue?vue&type=script&lang=js"
import style0 from "./no_pay_popup.vue?vue&type=style&index=0&id=4f70debf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70debf",
  null
  
)

export default component.exports